import { render, staticRenderFns } from "./SwipeIconGuide.vue?vue&type=template&id=5d75cf38&scoped=true"
import script from "./SwipeIconGuide.vue?vue&type=script&lang=js"
export * from "./SwipeIconGuide.vue?vue&type=script&lang=js"
import style0 from "./SwipeIconGuide.vue?vue&type=style&index=0&id=5d75cf38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d75cf38",
  null
  
)

export default component.exports